import { FC, Fragment, useState } from "react"
import { detectVowelBeginning } from "../util/string"
import { IoChevronDownOutline } from "react-icons/io5"
import classNames from "classnames"
import { Anchor } from "src/app/components/anchor"
const defaultContents = (breed: string, moreOnBreedsData: boolean) => {
  const content = [
    { name: "Characteristics", key: "Characteristics" },
    { name: "Appearance", key: "Appearance" },
    { name: "Personality", key: "Personality" },
    { name: "Exercise Needs", key: "Exercise" },
    { name: "Ideal Environment", key: "Environment" },
    { name: "Ideal Human", key: "Human" },
    { name: "Training", key: "Training" },
    { name: "Grooming", key: "Grooming" },
    { name: "Health", key: "Health" },
    { name: "Nutrition", key: "Nutrition" },
    { name: "History", key: "History" },
    {
      name: `Getting ${detectVowelBeginning(breed)} ${breed}`,
      key: `getting`,
    },
    {
      name: `Cost of Owning`,
      key: `cost-of-owning-${breed}`,
    },
    { name: `${breed} Rescues`, key: "rescues" },
    { name: `${breed} Breeders`, key: "breeders" },
  ]
  if (moreOnBreedsData) {
    content.push({
      name: `More on ${breed}s`,
      key: "more-on-breed",
    })
  }
  return content
}

const TableOfContents: FC<{ breed: string; moreOnBreedsData: boolean }> = ({
  breed,
  moreOnBreedsData,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const content = defaultContents(breed, moreOnBreedsData)

  return (
    <div className="bg-[#f1f4fb] p-4 sm:p-5 md:p-6 border-t-8 border-blue7 my-6 sm:my-8 md:my-10 py-4 sm:py-8 md:py-10">
      <div className="max-w-[1200px] mx-auto">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full flex items-center justify-between text-left md:cursor-default"
        >
          <h2 className="text-xl sm:text-2xl font-bold">Table of Contents</h2>
          <IoChevronDownOutline
            className={classNames(
              "h-5 w-5 sm:h-6 sm:w-6 transition-transform duration-200 md:hidden",
              isExpanded ? "transform rotate-180" : "",
            )}
          />
        </button>
        <ul
          className={classNames(
            "md:flex md:flex-wrap text-blue-600 font-medium p-0 text-left justify-start items-start",
            "transition-[max-height,opacity] duration-200 ease-in-out overflow-hidden",
            isExpanded
              ? "max-h-[2000px] opacity-100 mt-4"
              : "max-h-0 md:max-h-none opacity-0 md:opacity-100 md:mt-4",
          )}
        >
          {content.map((contentItem, index) => (
            <Fragment key={contentItem.key}>
              <li className="font-montserrat font-normal pb-3 sm:pb-4 text-[14px] sm:text-[15px]">
                <Anchor
                  href={`#${contentItem.key
                    .replace(/\s+/g, "-")
                    .toLowerCase()}`}
                  className="underline"
                >
                  {contentItem.name}
                </Anchor>{" "}
                {index !== content.length - 1 && (
                  <span className="px-4 text-black font-bold hidden md:inline-block">
                    •
                  </span>
                )}
              </li>
            </Fragment>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default TableOfContents
